/**
 * @license @tabler/icons-react v3.35.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M5 7l8 10m-8 0l8 -10", "key": "svg-0" }], ["path", { "d": "M21 11h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2", "key": "svg-1" }]];
const IconSuperscript = createReactComponent("outline", "superscript", "Superscript", __iconNode);

export { __iconNode, IconSuperscript as default };
//# sourceMappingURL=IconSuperscript.mjs.map
